<div class="bp-header">
  <span class="bp-header__title">{{ dialogCopy.titleKey | translate }}</span>
  <button
    mat-icon-button
    type="button"
    class="bp-header__close"
    (click)="cancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="bp-stepper">
    <div class="bp-step">
      <div
        class="bp-step__circle"
        [class.bp-step__circle--done]="step() === 'review'"
        [class.bp-step__circle--active]="step() === 'upload'">
        @if (step() === 'review') {
          <mat-icon>check</mat-icon>
        } @else {
          <span>1</span>
        }
      </div>
      <div
        class="bp-step__label"
        [class.bp-step__label--active]="step() === 'upload'">
        {{ 'GNR_UPLOAD_REVIEW_STEP_UPLOAD' | translate }}
      </div>
    </div>
    <div
      class="bp-step__connector"
      [class.bp-step__connector--done]="step() === 'review'"></div>
    <div class="bp-step">
      <div
        class="bp-step__circle"
        [class.bp-step__circle--active]="
          step() === 'review' && reviewState() !== 'extraction-failed'
        "
        [class.bp-step__circle--error]="reviewState() === 'extraction-failed'"
        [class.bp-step__circle--inactive]="step() === 'upload'">
        @if (reviewState() === 'extraction-failed') {
          <span>!</span>
        } @else {
          <span>2</span>
        }
      </div>
      <div
        class="bp-step__label"
        [class.bp-step__label--active]="step() === 'review'">
        {{ 'GNR_UPLOAD_REVIEW_STEP_REVIEW' | translate }}
      </div>
    </div>
  </div>

  @if (step() === 'upload') {
    <p class="bp-deal-name">{{ dealName }}</p>
    <p class="bp-helper">
      {{ dialogCopy.helperKey | translate }}
    </p>

    <div
      class="bp-upload"
      [class.bp-upload--drag]="dragCounter > 0"
      (drop)="handleDrop($event)"
      (dragenter)="dragEnter($event)"
      (dragleave)="dragLeave($event)"
      (dragover)="dragOver($event)"
      (click)="fileInput?.click()">
      <mat-icon class="bp-upload__icon">file_upload</mat-icon>
      <p class="bp-upload__title">
        {{ dialogCopy.uploadCtaKey | translate }}
      </p>
      <p class="bp-upload__hint">PDF</p>
      <input
        #fileInput
        type="file"
        accept=".pdf,application/pdf"
        hidden
        (change)="onFileInputChange($event)" />
    </div>

    @if (selectedFile(); as file) {
      <div class="bp-pill">
        <mat-icon class="bp-pill__icon">description</mat-icon>
        <span class="bp-pill__name">{{ file.name }}</span>
        @if (uploadPhase() === 'uploading' || uploadPhase() === 'extracting') {
          <mat-spinner
            class="bp-pill__spinner"
            diameter="14"
            mode="indeterminate"></mat-spinner>
        } @else {
          <button
            type="button"
            class="bp-pill__remove"
            aria-label="Remove file"
            (click)="removeFile($event)">
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>
    }

    @if (uploadPhase() === 'extracting') {
      <p class="bp-status">{{ dialogCopy.extractingStatusKey | translate }}</p>
    }
  }

  @if (step() === 'review') {
    @if (reviewState() === 'extraction-failed') {
      <div
        class="bp-upload bp-upload--compact"
        (drop)="handleDrop($event)"
        (dragenter)="dragEnter($event)"
        (dragleave)="dragLeave($event)"
        (dragover)="dragOver($event)"
        (click)="fileInput2?.click()">
        <mat-icon class="bp-upload__icon">file_upload</mat-icon>
        <p class="bp-upload__title">
          {{ dialogCopy.retryUploadCtaKey | translate }}
        </p>
        <p class="bp-upload__hint">PDF</p>
        <input
          #fileInput2
          type="file"
          accept=".pdf,application/pdf"
          hidden
          (change)="onFileInputChange($event)" />
      </div>

      <div class="bp-error">
        <mat-icon class="bp-error__icon">error_outline</mat-icon>
        <div>
          <div class="bp-error__title">
            {{ dialogCopy.extractionErrorTitleKey | translate }}
          </div>
          <div class="bp-error__body">
            {{ dialogCopy.extractionErrorBodyKey | translate }}
          </div>
        </div>
      </div>
    }

    @if (reviewState() === 'no-conflicts') {
      <div class="bp-success">
        <div class="bp-success__icon-wrap">
          <mat-icon class="bp-success__icon">check</mat-icon>
        </div>
        <div class="bp-success__title">
          {{ dialogCopy.noConflictsTitleKey | translate }}
        </div>
        <div class="bp-success__body">
          {{ dialogCopy.noConflictsBodyKey | translate: [dealName] }}
        </div>
      </div>
    }

    @if (reviewState() === 'has-conflicts') {
      <div class="bp-summary">
        <span class="bp-summary__text">{{ summaryText() }}</span>
        <button
          type="button"
          class="bp-summary__accept-all"
          (click)="acceptAllFromDocument()">
          {{ 'GNR_UPLOAD_REVIEW_ACCEPT_ALL_FROM_DOCUMENT' | translate }}
        </button>
      </div>
      <div class="bp-table-wrap">
        <table class="bp-table">
          <thead>
            <tr>
              <th class="bp-table__col-field">
                {{ 'GNR_UPLOAD_REVIEW_FIELD' | translate }}
              </th>
              <th class="bp-table__col-value">
                {{ 'GNR_UPLOAD_REVIEW_CURRENT_VALUE' | translate }}
              </th>
              <th class="bp-table__col-value">
                {{ 'GNR_UPLOAD_REVIEW_DOCUMENT_VALUE' | translate }}
              </th>
              <th class="bp-table__col-keep">
                {{ 'GNR_UPLOAD_REVIEW_KEEP' | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            @for (row of conflictRows(); track row.key) {
              <tr [class.bp-table__row--empty]="row.isCurrentEmpty">
                <td class="bp-table__field">{{ row.label }}</td>
                <td>
                  @if (row.isCurrentEmpty) {
                    <span class="bp-empty">
                      {{ 'GNR_UPLOAD_REVIEW_NO_VALUE' | translate }}
                    </span>
                  } @else {
                    {{ row.currentDisplay }}
                  }
                </td>
                <td>{{ row.documentDisplay }}</td>
                <td>
                  <div class="bp-toggle-group">
                    <button
                      type="button"
                      class="bp-toggle-pill"
                      [class.bp-toggle-pill--selected]="
                        row.selection === 'current'
                      "
                      [attr.aria-pressed]="row.selection === 'current'"
                      (click)="setSelection(row.key, 'current')">
                      {{ 'GNR_UPLOAD_REVIEW_KEEP_CURRENT' | translate }}
                    </button>
                    <button
                      type="button"
                      class="bp-toggle-pill"
                      [class.bp-toggle-pill--selected]="
                        row.selection === 'document'
                      "
                      [attr.aria-pressed]="row.selection === 'document'"
                      (click)="setSelection(row.key, 'document')">
                      {{ 'GNR_UPLOAD_REVIEW_KEEP_DOCUMENT' | translate }}
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      @if (dialogCopy.reviewNoteKey) {
        <div class="bp-status">
          {{ dialogCopy.reviewNoteKey | translate }}
        </div>
      }
    }
  }
</mat-dialog-content>

<mat-dialog-actions class="bp-actions">
  @if (step() === 'review' && reviewState() !== 'extraction-failed') {
    <button type="button" class="bp-btn bp-btn--back" (click)="back()">
      ← {{ 'GNR_UPLOAD_REVIEW_BACK' | translate }}
    </button>
  } @else {
    <button type="button" class="bp-btn bp-btn--cancel" (click)="cancel()">
      {{ 'GNR_CANCEL' | translate }}
    </button>
  }

  <div class="bp-actions__right">
    @if (step() === 'upload') {
      <button
        type="button"
        class="bp-btn bp-btn--primary"
        [disabled]="!canAdvanceFromUpload()"
        (click)="next()">
        {{ 'GNR_UPLOAD_REVIEW_NEXT' | translate }}
        <mat-icon class="bp-btn__icon">arrow_forward</mat-icon>
      </button>
    } @else if (reviewState() === 'has-conflicts') {
      <button
        type="button"
        class="bp-btn bp-btn--primary"
        [disabled]="saving()"
        (click)="confirmSelection()">
        {{ dialogCopy.conflictsActionKey | translate }}
        <mat-icon class="bp-btn__icon">arrow_forward</mat-icon>
      </button>
    } @else if (reviewState() === 'no-conflicts') {
      <button
        type="button"
        class="bp-btn bp-btn--primary"
        [disabled]="saving()"
        (click)="confirmSelection()">
        {{ dialogCopy.noConflictsActionKey | translate }}
        @if (dialogCopy.showNoConflictsActionIcon) {
          <mat-icon class="bp-btn__icon">arrow_forward</mat-icon>
        }
      </button>
    }
  </div>
</mat-dialog-actions>
